import {FormUtils} from "../utils/FormUtils";
import {receive} from '../result/ResultActions';
import {finish} from "../steps/StepsActions";
import {OrdersHttpService} from '../http/OrdersHttpService';

const applepaySuccessCallback = (order) => {
  console.log('On applepay success: ', order);
  applepayFinish(null, order, false);
};

const applepayErrorCallback = error => {
  console.log('On applepay error: ', error);
  applepayFinish(error, null, false);
};

const applepayCancelCallback = () => {
	console.log('On applepay cancel');
};

const applepayFinish = (error, result, executeRequired) => {
  if (result && result.orderId) {
    OrdersHttpService.getOrder(result.orderId)
    .then(response => {
      receive(error, result, response, null, null, executeRequired, 'applepay');
      finish();
    });
  } else {
    receive(error, result, null);
    finish();
  }
}

const validateMerchant = (validateMerchantUrl, validationURL) => {
	return fetch(validateMerchantUrl + '?validationURL=' + validationURL, {
		method: 'GET'
	}).then(function(res) {
		return res.json();
	}).catch(function (error) {
		return error;
	});
}

const getOptionalParameters = params => {
	const result = {
		merchantIdentifier: params.merchantIdentifier,
		displayName: params.displayName,
		countryCode: params.countryCode,
		applepayCallbacks: params.applepayCallbacks,
		useBillingAndShipping: params.useBillingAndShipping,
		onValidateMerchant: (resolve, reject, validationURL) => {
			validateMerchant(params.validateMerchantUrl, validationURL)
				.then(res => {
					if (res.error) {
						return reject(res.error);
					}

					return resolve(res.session);
				})
				.catch(error => {
					return reject(error);
				});
		}
	};
	
	if (params.styles) {
		result.styles = FormUtils.getValuesByUsage(params.stylesUsage, params.styles);
	}

	if (params.applepayCallbacks) {
    result.successCallback = applepaySuccessCallback;
		result.errorCallback = applepayErrorCallback;
		result.cancelCallback = applepayCancelCallback;
	}

	return result;
}

const getResultCallbacksTemplate = () => {
  return `
function resultCallback(error, results) {
  console.log('Error/Result:', error, results);
}

function applepayErrorCallback(error) {
  console.log('On applepay error: ', error);
}

function applepayCancelCallback() {
  console.log('On applepay cancel');
}

function applepaySucccessCallback(orderId) {
  console.log('On applepay success: ', orderId);
}
    `;
}

const getCallbacksTemplate = () => {
  return `
optionalParameters.applepay.errorCallback = applepayErrorCallback;
optionalParameters.applepay.cancelCallback = applepayCancelCallback;
optionalParameters.applepay.successCallback = applepaySucccessCallback;
  `;
}

export const ApplePayHelper = {
  getOptionalParameters,
  getResultCallbacksTemplate,
  getCallbacksTemplate
};



// WEBPACK FOOTER //
// ./src/helpers/ApplePayHelper.js